import DescriptionList from 'ant-design-pro/lib/DescriptionList';
import Description from 'ant-design-pro/lib/DescriptionList/Description';
import PageHeader from 'ant-design-pro/lib/PageHeader';
import { Empty, Table } from 'antd';
import gql from 'graphql-tag';
import React, { Component } from 'react';
import { Query } from 'react-apollo';
import { Link } from 'react-router-dom';
import { Panel } from 'src/components/Panel';
import { FormatDate } from 'src/components/table/Date';

import { UserData } from './Enrollment';

const attendancelogsQuery = gql`
  query getAttendancelogsQuery($ids: [ID], $enrollmentIds: [Int], $lessonIds: [ID], $serialId: String) {
    users(ids: $ids) {
      id
      name
      enrollments(ids: $enrollmentIds) {
        id
        skuId
        sku {
          id
          name
        }
        lessonProgresses(serialId: $serialId) {
          serialId
          lesson {
            id
            name
            type
          }
        }
        attendances(lessonIds: $lessonIds) {
          id
          lessonId
          enrollmentId
          uuid
          parts
          createdAt
          startAt
        }
      }
    }
  }
`;

interface Props {
  match: any;
}

interface State {}

export class Attendances extends Component<Props, State> {
  render() {
    const { id, enrollmentId, lessonId, serialId } = this.props.match.params;
    return (
      <Query<UserData>
        query={attendancelogsQuery}
        variables={{ serialId, lessonIds: [lessonId], ids: [id], enrollmentIds: [enrollmentId] }}
      >
        {({ loading, error, data }) => {
          if (error) return <div>{error.message}</div>;
          if (loading) return <div>loading...</div>;
          if (!data) {
            // @ts-ignore
            return <Empty />;
          }
          const [user] = (data && data.users) || [null];

          const [enrollment] = user && user.enrollments;
          const attendances = (enrollment && enrollment.attendances) || [];
          const sku = enrollment && enrollment.sku;
          const lessonProgresses = enrollment && enrollment.lessonProgresses;
          const [lessonProgresse] = lessonProgresses;
          return (
            <>
              <PageHeader
                title={sku.name}
                content={
                  enrollment && (
                    <DescriptionList size="small" title="课程">
                      <Description term="课时">{lessonProgresse.lesson.name}</Description>
                    </DescriptionList>
                  )
                }
              />
              <Panel style={{ marginTop: 10 }}>
                <Table
                  dataSource={attendances}
                  pagination={false}
                  rowKey={attendance => `${attendance.id}`}
                  loading={loading}
                >
                  <Table.Column title="ID" dataIndex="id" key="id" />
                  <Table.Column title="enrollmentId" dataIndex="enrollmentId" key="enrollmentId" />
                  <Table.Column title="lessonId" dataIndex="lessonId" key="lessonId" />
                  <Table.Column title="uuid" dataIndex="uuid" key="uuid" />
                  <Table.Column title="parts" dataIndex="parts" render={parts => <span>[{parts}]</span>} />
                  <Table.Column
                    title="createdAt"
                    dataIndex="createdAt"
                    key="createdAt"
                    render={createdAt => <FormatDate mode="datetime" date={createdAt} />}
                  />
                  <Table.Column
                    title="startAt"
                    dataIndex="startAt"
                    key="startAt"
                    render={startAt => <FormatDate mode="datetime" date={startAt} />}
                  />
                  <Table.Column
                    title="操作"
                    key="action"
                    render={row => (
                      <>
                        <Link
                          to={`/user/${id}/enrollment/${enrollmentId}/serial/${serialId}/attendance/${row.id}/${lessonId}/attendanceLogs`}
                          style={{ marginLeft: 8 }}
                        >
                          查看attendceLogs
                        </Link>
                      </>
                    )}
                  />
                </Table>
              </Panel>
            </>
          );
        }}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/enrollment/Attendances.tsx